import React, { FC, useRef } from "react";
import { Tags } from "../tags";
import { useInView } from "@/hooks/reveal-in-view";
import type { WhitePaperProductProps } from "@/types/components/p2p-money-abroad/white-paper-product";
import SplitTextAnimation from "../split-text-animation";

export const WhitePaperProduct: FC<WhitePaperProductProps> = ({
  title,
  tags,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="whiteLabelProduct">
      <div className="wrapper">
        <SplitTextAnimation
          htmlElement={
            <h2 className="whiteLabelProduct--title" ref={ref}>
              {title}
            </h2>
          }
          isInView={isInView}
        />
      </div>
      <Tags tags={tags} className="whiteLabelProduct--tags" />
    </section>
  );
};
